import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ApiService } from '../../../services/api.service';
import Swal from 'sweetalert2';
import { io } from 'socket.io-client';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css']
})
export class LandingComponent implements OnInit {
  @ViewChild('closeAddExpenseModal') closeAddExpenseModal!: ElementRef;

  login!: boolean;
  login_form!: FormGroup;
  admin_id: any;
  visitor: any = []
  mode: any
  socket: any;

  constructor(
    public router: Router,
    public formBuilder: FormBuilder,
    public services: ApiService) { }

  ngOnInit(): void {
    // this.services.startPage()
    this.login_form = this.formBuilder.group({
      user: '',
      password: ''
    });
    // this.socket = io('https://ogc.mapedia.co.th/api/v2/lrfund/');
    this.services.get('m_countofuser').then((res: any) => {
      this.getCounter(res);
    })
    // this.socket.on('output', (res: any) => {
    //   this.getCounter(res);
    // });
  }

  closeModal() {
    this.login_form.reset();
  }

  async onClickLogin() {
    // document.getElementById('login_btn')!.dataset.target = "#select_mode";
    this.admin_id = null
    await this.services.login_user(this.login_form.value).then(async (res: any) => {
      if (res.length != 0) {
        res.forEach((type: any) => {
          this.mode = type.branch
        });
        this.admin_id = await res[0].id;
        localStorage.setItem("admin_data", JSON.stringify(res[0]));
        this.onClick(await res[0].branch, await res[0].username, await res[0].status)
      } else {
        this.login_form.reset();
        Swal.fire({
          title: 'เข้าสู่ระบบไม่สำเร็จ',
          text: 'กรุณาตรวจสอบ ชื่อผู้ใช้ หรือ รหัสผ่าน ให้ถูกต้อง',
          icon: 'error',
          confirmButtonText: `ตกลง`,
        }).then((res: any) => {
          if (res) {
            this.closeAddExpenseModal.nativeElement.click();
          }
        })
        this.onClick()

      }
    })
  }
  onClickManage() {
    window.location.href = "https://ogc.mapedia.co.th/lrfund-general/#/check-login/" + this.admin_id;
  }
  onClickAnalyze() {
    window.location.href = "https://ogc.mapedia.co.th/lrfund-invest/#/check-login/" + this.admin_id;
  }

  async getCounter(data: any) {
    let counnt_visitor = (data.length).toString()
    this.visitor = [];
    for (let j = 0; j < counnt_visitor.length; j++) {
      this.visitor.push(counnt_visitor[j])
    }
    for (let x = 0; x < 6; x++) {
      if (this.visitor.length < 6) {
        this.visitor.splice(0, 0, 0);
      }
    }
  }

  onClick(branch?: any, username?: any, status?: any) {

    const clickData = {
      branch: "guest",
      username: ""
    }
    if (branch) {
      if (branch == 'invest') {

        if (status == 'admin') {
          clickData.branch = branch
          clickData.username = username
        } else {
          clickData.branch = status
          clickData.username = username
        }
      } else {
        clickData.branch = branch
        clickData.username = username
      }
    }
    this.services.create('m_countofuser', clickData).then((res: any) => {
      this.services.get('m_countofuser').then((res: any) => {
        //this.socket.emit('output', res)
        this.getCounter(res)
      })
    })
  }

  onClickHere() {
    // window.location.href = "http://office.dpt.go.th/lrfund/";
    window.open('http://office.dpt.go.th/lrfund/', '_blank');
  }
}
